import { combineReducers } from 'redux'
import * as ActionTypes from '../../actions/actionTypes'

/** @reducer **/
const entities = (state = {}, action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_PRIVATE_ROOMS_FETCH_SUCCESS:
            return { ...state, privateRooms: [...action.data] }
        case ActionTypes.OMNITEC_PRIVATE_ROOMS_CREATE_SUCCESS:
            return {
                ...state,
                privateRooms: [...state.privateRooms, action.data]
            }
        case ActionTypes.OMNITEC_PRIVATE_ROOMS_DELETE_SUCCESS:
            return { ...state, privateRooms: [...state.privateRooms.filter(item => item.id !== action.data)] }
        default:
            return state
    }
}

/** @reducer **/
const result = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_PRIVATE_ROOMS_FETCH_SUCCESS:
            return [...action.data]
        case ActionTypes.OMNITEC_PRIVATE_ROOMS_CREATE_SUCCESS:
            return [...state, action.data]
        case ActionTypes.OMNITEC_PRIVATE_ROOMS_DELETE_SUCCESS:
            return [...state.filter(item => item.id !== action.data)]
        default:
            return state
    }
}

/** @reducer **/
const isFetching = (state = false, action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_PRIVATE_ROOMS_FETCH_REQUEST:
            return true
        case ActionTypes.OMNITEC_PRIVATE_ROOMS_FETCH_SUCCESS:
            return false
        case ActionTypes.OMNITEC_PRIVATE_ROOMS_FETCH_FAILURE:
            return false
        default:
            return state
    }
}

/** @reducer **/
const error = (state = null, action) => {
    switch (action.type) {
        case ActionTypes.OMNITEC_PRIVATE_ROOMS_FETCH_FAILURE:
            return action.data
        case ActionTypes.OMNITEC_PRIVATE_ROOMS_CREATE_FAILURE:
            return action.data
        case ActionTypes.OMNITEC_PRIVATE_ROOMS_DELETE_FAILURE:
            return action.data
        default:
            return state
    }
}

export default combineReducers({ entities, isFetching, result, error })



// WEBPACK FOOTER //
// ./src/reducers/omnitecReducers/omnitecPrivateRooms.js